import { fmtHours } from "../../lib/labels";

const Kpi = ({ label, value, hint, testId }) => (
  <div className="card-surface p-4" data-testid={testId}>
    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
    <p className="mt-1 font-display text-2xl font-bold tabular-nums text-slate-900" data-testid={`${testId}-value`}>{value}</p>
    {hint && <p className="mt-0.5 text-xs text-slate-400">{hint}</p>}
  </div>
);

const pct = (v) => (v === null || v === undefined ? "—" : `${v} %`);

export default function FeedbackStats({ stats }) {
  if (!stats) return null;
  return (
    <div className="mb-6 grid grid-cols-2 gap-3 md:grid-cols-4" data-testid="feedback-stats">
      <Kpi testId="kpi-total" label="Feedbacks" value={stats.total} hint={`${stats.open} ouvert(s) · ${stats.unassigned} non affecté(s)`} />
      <Kpi testId="kpi-avg" label="Note moyenne" value={stats.avg_rating ?? "—"} hint="sur 5" />
      <Kpi testId="kpi-resolution" label="Taux de résolution" value={pct(stats.resolution_rate)} hint={`${stats.resolved} résolu(s) ou clôturé(s)`} />
      <Kpi testId="kpi-response" label="Taux de réponse" value={pct(stats.response_rate)} hint="réponse visible par l'usager" />
      <Kpi testId="kpi-take" label="Prise en charge" value={fmtHours(stats.avg_take_charge_hours)} hint="délai moyen" />
      <Kpi testId="kpi-first-response" label="Première réponse" value={fmtHours(stats.avg_first_response_hours)} hint="délai moyen" />
      <Kpi testId="kpi-resolve" label="Résolution" value={fmtHours(stats.avg_resolution_hours)} hint="délai moyen" />
      <Kpi testId="kpi-open-complaints" label="Réclamations ouvertes" value={stats.open_complaints} hint={`dont ${stats.sensitive_open} sensible(s)`} />
    </div>
  );
}
